import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import TimeshareReviews from "@/pages/TimeshareReviews";
import TimesharePresentations from "@/pages/TimesharePresentations";
import TimeshareDetail from "@/pages/TimeshareDetail";
import TravelClubReviews from "@/pages/TravelClubReviews";
import ClubDetail from "@/pages/ClubDetail";
import ClubPresentation from "@/pages/ClubPresentation";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import MemberGuide from "@/pages/MemberGuide";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Partners from "@/pages/Partners";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import AccessibilityStatement from "@/pages/AccessibilityStatement";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/timeshare-reviews" element={<TimeshareReviews />} />
              <Route path="/timeshare-reviews/presentation-guide" element={<TimesharePresentations />} />
              <Route path="/timeshare-reviews/:slug" element={<TimeshareDetail />} />
              <Route path="/travel-club-reviews" element={<TravelClubReviews />} />
              <Route path="/travel-club-reviews/:slug" element={<ClubDetail />} />
              <Route path="/travel-club-reviews/:slug/presentation" element={<ClubPresentation />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/:slug" element={<GuideDetail />} />
              <Route path="/members" element={<MemberGuide />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/member-guides/:slug" element={<BlogPost />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/accessibility" element={<AccessibilityStatement />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/packages/:slug" element={<PackageDetail />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
